import { render, staticRenderFns } from "./ArticleBodyV5.vue?vue&type=template&id=606237b5&scoped=true&"
import script from "./ArticleBodyV5.vue?vue&type=script&lang=js&"
export * from "./ArticleBodyV5.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBodyV5.vue?vue&type=style&index=0&id=606237b5&scoped=true&lang=css&"
import style1 from "./ArticleBodyV5.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606237b5",
  null
  
)

export default component.exports